/**
 * Currency conversion utilities for Indian Rupee (INR)
 * 1 Rupee = 100 Paise
 */

/**
 * Converts rupees to paise
 * @param rupees - Amount in rupees (can be decimal)
 * @returns Amount in paise (integer)
 */
export const rupeesToPaise = (rupees: number): number => {
  return Math.round(rupees * 100);
};

/**
 * Converts paise to rupees
 * @param paise - Amount in paise (integer)
 * @returns Amount in rupees (decimal with 2 decimal places)
 */
export const paiseToRupees = (paise: number): number => {
  return Number((paise / 100).toFixed(2));
};
